module.exports = __webpack_public_path__ + "img/moble_home2.fe0c0975.png";